<template>
  <div class="baseInfo">
    <div class="main-row flex">
      <div style="flex: 1">
        <div class="title-name main-row">数据库名称</div>

        <div class="main-row flex a-c">
          <div class="row-tip">展示名称</div>
          <div class="input-container" style="font-weight: 600">
            <el-input v-model="state.params.name" show-word-limit maxlength="200" placeholder="请输入数据库名称"/>
          </div>
        </div>
        <div class="main-row flex">
          <div class="row-tip">别名/曾用名</div>
          <div class="input-container">
            <div class="input-div" v-for="(item,index) in state.aliasList">
              <el-input v-model="item.name" show-word-limit maxlength="200" placeholder="请输入数据库别名/曾用名"/>
              <i class="iconfont unify-shanchu" @click="deleteOne(index)" v-if="index!=0"></i>
            </div>
            <div class="add-tip" @click="addLinkArr">添加一个别名/曾用名</div>

          </div>
        </div>
      </div>
      <div class="main-row database-logo" style="width: 230px">
        <div class="title-name" style="margin-bottom: 20px">数据库LOGO</div>
        <el-upload
            class="avatar-uploader"
            action="action"
            :http-request="changeImage"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg,.gif"
        >
          <div class="avatar" v-if="state.params.logoPath" :style="`background:url(${state.params.logoPath})`"></div>
          <el-icon v-else class="avatar-uploader-icon">
            <Plus/>
          </el-icon>
        </el-upload>
      </div>
    </div>
    <div class="main-row">
      <div class="title-name" style="margin-bottom: 20px">资源简介</div>
      <el-input
          v-model="state.params.resourceIntroduction"
          type="textarea"
          :rows="8"
          show-word-limit
          maxlength="3000"
          placeholder="请输入资源简介"
      />
      <!-- <tinyMceEditor :defaultId="'resourceIntroduction'" key="resourceIntroduction"
                     ref="resourceIntroduction"
                     @update:modelValue="(val)=>updateContent('resourceIntroduction',val)"/> -->
    </div>
    <div class="main-row">
      <div class="title-name flex a-c j-s" style="margin-bottom: 20px">
        <span>资源详情</span>
        <div class="title-right flex a-c">
          <el-switch
              @change="confirm"
              :active-value="1"
              :inactive-value="0"
              v-model="state.params.resourceDetailFlag"
              :before-change="beforeChange"
              active-color="#2054D6"
              size="large"
          />
          <div class="expand-toggle flex a-c" @click="detailsExpanded = !detailsExpanded">
            <span>{{ detailsExpanded ? '收起' : '展开' }}</span>
            <el-icon><ArrowUp v-if="detailsExpanded" /><ArrowDown v-else /></el-icon>
          </div>
        </div>
      </div>
      <div class="editor-collapse-wrap" :class="detailsExpanded ? 'expanded' : 'collapsed'">
        <tinyMceEditor :defaultId="'resourceDetails'" key="resourceDetails"
                       ref="resourceDetails"
                       @update:modelValue="(val)=>updateContent('resourceDetails',val)"/>
      </div>
    </div>
    <div class="main-row" v-if="isNankai">
      <div class="title-name flex a-c j-s" style="margin-bottom: 20px">
        <span>使用帮助</span>
        <div class="title-right flex a-c">
          <el-switch
              @change="confirmHelp"
              :active-value="1"
              :inactive-value="0"
              v-model="state.params.helpContentFlag"
              :before-change="beforeChange"
              active-color="#2054D6"
              size="large"
          />
          <div class="expand-toggle flex a-c" @click="helpExpanded = !helpExpanded">
            <span>{{ helpExpanded ? '收起' : '展开' }}</span>
            <el-icon><ArrowUp v-if="helpExpanded" /><ArrowDown v-else /></el-icon>
          </div>
        </div>
      </div>
      <div class="editor-collapse-wrap" :class="helpExpanded ? 'expanded' : 'collapsed'">
        <tinyMceEditor :defaultId="'helpContent'" key="helpContent"
                       ref="helpContent"
                       @update:modelValue="(val)=>updateContent('helpContent',val)"/>
      </div>
    </div>
    <div class="main-row" v-if="isNankai">
      <div class="title-name flex a-c j-s" style="margin-bottom: 20px">
        <span>备注</span>
        <div class="expand-toggle flex a-c" @click="remarkExpanded = !remarkExpanded">
          <span>{{ remarkExpanded ? '收起' : '展开' }}</span>
          <el-icon><ArrowUp v-if="remarkExpanded" /><ArrowDown v-else /></el-icon>
        </div>
      </div>
      <div class="editor-collapse-wrap" :class="remarkExpanded ? 'expanded' : 'collapsed'">
        <tinyMceEditor :defaultId="'remark'" key="remark"
                       ref="remark"
                       @update:modelValue="(val)=>updateContent('remark',val)"/>
      </div>
    </div>

    <el-affix position="bottom" :offset="20">
      <div class="button-container flex a-c j-c">
        <el-button color="#626aef" @click="submit">保存</el-button>
        <el-button color="#626aef" plain @click="reset">重置</el-button>
      </div>
    </el-affix>

  </div>
</template>

<script>
import tinyMceEditor from "@/components/untils/tinyMceEditor"
import {reactive, ref, computed, onMounted, nextTick} from "vue";
import {useRoute} from 'vue-router'
import {Plus} from '@element-plus/icons-vue';
import {ElMessage, ElMessageBox} from 'element-plus';
import store from "@/store/index";
import {
  findOneManagerDatabaseDetailsById,
  saveManagerDatabaseDetailsBaseInfo,
  uploadFileByMultipartFile,
  switchResourceDetailFlag,
  switchHelpContentFlag
} from "@/js/network/main"
import {MessageBox} from "@/js/utils/commonJs";

export default {
  name: "baseInfo1",
  components: {
    tinyMceEditor,
    Plus
  },
  setup(props, {attrs, slots, emit, expose}) {
    const route = useRoute();

    const resourceDetails = ref(null);
    const helpContent = ref(null);
    const remark = ref(null);
    // const resourceIntroduction = ref(null);

    // 使用帮助/备注仅南开(sId=129)显示
    const isNankai = computed(() => {
      const userData = store.state.user.userData || {};
      const sId = Number(userData.schoolId || userData.sId);
      return sId === 129;
    });

    // 资源详情/使用帮助/备注 富文本默认收起
    const detailsExpanded = ref(false);
    const helpExpanded = ref(false);
    const remarkExpanded = ref(false);

    // 资源详情前台显示开关（数据库详情字段）
    let isFirst = ref(true);
    const confirm = () => {
      if(isFirst.value){
        return;
      }
      // 开关打开时，若资源详情未展开则自动展开；关闭时若已展开则收起
      if(state.params.resourceDetailFlag == 1){
        detailsExpanded.value = true;
      } else {
        detailsExpanded.value = false;
      }
      switchResourceDetailFlag({id: route.query.id, dId: route.query.dId}).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        MessageBox.success("操作成功！");
      }).catch(error => {
        console.log(error, "catchError");
      });
    }
    // 使用帮助开关
    const confirmHelp = () => {
      if(isFirst.value){
        return;
      }
      // 开关打开时，若使用帮助未展开则自动展开；关闭时若已展开则收起
      if(state.params.helpContentFlag == 1){
        helpExpanded.value = true;
      } else {
        helpExpanded.value = false;
      }
      switchHelpContentFlag({id: route.query.id}).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        MessageBox.success("操作成功！");
      }).catch(error => {
        console.log(error, "catchError");
      });
    }
    const beforeChange = function () {
      isFirst.value = false;
      return new Promise((resolve, reject) => {
        ElMessageBox.confirm('确定要执行本操作吗?').then((aaa) => {
          if (aaa) {
            resolve(true);
          }
          reject(false);
        }).catch(() => {
          reject(false);
        })
      })
    }

    let state = reactive({
      params: {
        name: "",
        logoPath: "",
        resourceIntroduction: "",
        resourceDetails: ""
      },
      aliasList: [],
    });

    let stateCopy = {
      params: {
        name: "",
        logoPath: "",
        resourceIntroduction: "",
        resourceDetails: ""
      },
      aliasList: [],
    }
    const updateContent = (key, val) => {
      state.params[key] = val;
    }
    const handleAvatarSuccess = function (response, uploadFile) {

    }
    const beforeAvatarUpload = function (rawFile) {
      
      const isJPG = rawFile.type == "image/jpeg"  || rawFile.type == "image/png" || rawFile.type == "image/jpg" || rawFile.type == "image/gif";
      if (!isJPG) {
        ElMessage.error('图片必须是jpeg,png,jpg,gif格式!')
        return false
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error('照片大小不得超过2MB!')
        return false
      }
      return true
    }
    const changeImage = function (param) {
      console.log('param上传图片 ', param);
      var form = new FormData();
      form.append("file", param.file);

      uploadFileByMultipartFile(form)
          .then((res) => {
            if (!res.success) {
              MessageBox.error(res.msg);
              return;
            }
            state.params.logoPath = res.data.url;
          })
          .catch((error) => {
            //MessageBox.error(error);
            console.log(error, "catchError");
          });
    }
    const deleteOne = function (index) {
      state.aliasList.splice(index, 1);
    }
    const addLinkArr = function () {
      state.aliasList.push({})
    }
    const submit = () => {
      ElMessageBox.confirm('确定要执行本操作吗?').then((aaa) => {
        if (aaa) {
          // resourceDetailFlag/helpContentFlag由开关接口单独维护，保存时不传
          const { resourceDetailFlag, helpContentFlag, ...restParams } = state.params;
          let params = {
            ...restParams,
            aliasList: state.aliasList.map(r => r.name),
            id: route.query.id,
            dId: route.query.dId
          }
          saveManagerDatabaseDetailsBaseInfo(params).then(res => {
            if (!res.success) {
              MessageBox.error(res.msg);
              return;
            }
            MessageBox.success("保存成功！");
            // window.location.reload();
          }).catch(error => {
            console.log(error, "catchError");
          });
        }
      }).catch(() => {

      })

    }
    const reset = () => {
      state.params = JSON.parse(JSON.stringify(stateCopy.params || {}));
      state.aliasList = JSON.parse(JSON.stringify(stateCopy.aliasList || []));
      // resourceIntroduction.value.handleSetContent(state.params.resourceIntroduction || "");
      resourceDetails.value.handleSetContent(state.params.resourceDetails || "");
      helpContent.value.handleSetContent(state.params.helpContent || "");
      remark.value.handleSetContent(state.params.remark || "");

    }

    const init = function () {
      let {id, dId} = route.query
      findOneManagerDatabaseDetailsById({id, dId}).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        if (!res || !res.data) {
          return;
        }
        let arr = [];
        if (res.data.aliasList && res.data.aliasList.length > 0) {
          res.data.aliasList.map(r => {
            let obj = {}
            obj.name = r;
            arr.push(obj);
          });
        } else {
          arr.push({});
        }
        state.params = res.data;
        state.aliasList = arr;
        // 回显开关为开启状态时，资源详情/使用帮助默认展开
        if(res.data.resourceDetailFlag == 1){
          detailsExpanded.value = true;
        }
        if(res.data.helpContentFlag == 1){
          helpExpanded.value = true;
        }
        // 备注接口返回有数据时默认展开
        if(res.data.remark){
          remarkExpanded.value = true;
        }

        stateCopy.params = {...res.data};
        stateCopy.aliasList = [...arr];
        console.log('state.params: ', state.params);
        nextTick(() => {
          // resourceIntroduction.value.handleSetContent(state.params.resourceIntroduction || "");
          resourceDetails.value.handleSetContent(state.params.resourceDetails || "");
          helpContent.value.handleSetContent(state.params.helpContent || "");
          remark.value.handleSetContent(state.params.remark || "");
        })

      }).catch(error => {
        //MessageBox.error(error);
        console.log(error, "catchError");
      });
    }
    onMounted(() => {
      console.log(1111);
      setTimeout(()=>{
        init();
      },400)
    });

    return {
      // resourceIntroduction,
      resourceDetails,
      helpContent,
      remark,
      isNankai,
      state,
      updateContent,
      init,
      handleAvatarSuccess,
      beforeAvatarUpload,
      changeImage,
      deleteOne,
      addLinkArr,
      submit,
      reset,
      detailsExpanded,
      helpExpanded,
      remarkExpanded,
      confirm,
      confirmHelp,
      beforeChange,
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.baseInfo {
  position: relative;
  padding-bottom: 38px;

  .button-container {
    padding: 10px 0;
    background-color: white;
  }
}

.title-name {
  margin-top: 10px;
  font-size: 18px;
  font-weight: 600;
  color: #232323;

  .title-right {
    gap: 12px;
  }
}

//.database-logo{
//  position: absolute;
//  top: -5px;
//  right: 20px;
//}
.main-row {
  margin-bottom: 25px;
}

.row-tip {
  font-size: 14px;
  font-weight: 600;
  color: #232323;
  width: 120px;
}

.input-container {
  width: 600px;
  padding-right: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.input-div {
  position: relative;
  margin-bottom: 8px;

  .iconfont {
    position: absolute;
    right: -20px;
    top: 8px;
    cursor: pointer;
    color: #333333;
  }
}

//.avatar-uploader{
//  width: 200px;
//  height: 135px;
//}
//:deep(.avatar-uploader-icon){
//  width: 200px;
//  height: 135px;
//}


.avatar-uploader .avatar {
  width: 200px;
  height: 135px;
  border: 1px solid #DED9D9;
  border-radius: 9px 9px 9px 9px;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

:deep(.avatar-uploader .el-upload) {
  border: 1px dashed var(--el-border-color) !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 188px;
  height: 130px;
  text-align: center;
}

.add-tip {
  font-size: 14px;
  color: #3157b9;
  cursor: pointer;
  user-select: none;
}

.editor-collapse-wrap{
  &.collapsed{
    max-height: 0;
    overflow: hidden;
  }
}

.expand-toggle{
  padding: 6px 0;
  font-size: 13px;
  color: #257dd9;
  cursor: pointer;
  user-select: none;
  gap: 4px;
}

</style>
